import React, { useContext } from 'react';  
import AuthContext from '../contex/AuthProvider'; // Import your AuthContext  
import HomeSlider from '../Homehelp/HomeSlider';  
import OurEstate from '../Homehelp/OurEstate';  
import VideoAds from '../Homehelp/VideoAds';  
import FeaturedProp from '../Homehelp/FeaturedProp';  
import OurServices from '../Homehelp/OurServices';  

function Home() {  
    const { auth } = useContext(AuthContext); // Retrieve auth context  

    // Destructure user information from auth  
    const user = auth.user;  

    return (  
        <div className='flex flex-col gap-5 justify-center items-center'>  
            <div className='mt-[120px]'>  
                {user ? ( // Check if user data exists  
                    <h1 className='text-center text-slate-500 text-[20px] font-medium bg-slate-100 px-20 py-4 shadow-lg'>  
                        Welcome to Mercyland Admin, {user.firstName}.  
                    </h1>  
                ) : (  
                    <h1 className='text-center text-slate-500 text-[20px] font-medium bg-slate-100 px-20 py-4 shadow-lg'>  
                        Welcome to Mercyland Admin.  
                    </h1>  
                )}  
            </div>  
            <div className='flex flex-wrap justify-center gap-20 py-10 mx-[100px]'>  
                <HomeSlider />  
                <OurServices />  
                <VideoAds />  
                <FeaturedProp />  
                <OurEstate />  
            </div>  
        </div>  
    );  
}  

export default Home;